<template>
  <v-expansion-panels v-bind="attributes">
    <v-expansion-panel
      v-for="i in 3"
      :key="i"
      expand-icon="far fa-chevron-down"
      collpase-icon="far fa-chevron-up"
      title="Item"
      text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    >
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { VExpansionPanels } from "vuetify/components"

type KTreeviewProps = Partial<InstanceType<typeof VExpansionPanels>["$props"]>

export default defineComponent<KTreeviewProps, { attributes: any }>({
  props: VExpansionPanels.props,
  computed: {
    attributes() {
      const props = {
        ...(this.$props as Record<string, any>),
        ...this.$attrs,
        variant: "accordion",
      }
      return props
    },
  },
})
</script>
